import { useTranslation } from "react-i18next";
import moment from "moment";
import FormDateRangeInput from "form/FormDateRangeInput";
import { ACTION_VIEW_MODE } from "constants/action-form";
import DetailSection from "../../details/DetailSection";

const PerformedDateSpan = ({ viewMode }) => {
  const { t } = useTranslation();

  const isViewMode = viewMode === ACTION_VIEW_MODE.view;

  return (
    <DetailSection
      isRequired={!isViewMode}
      title={t("ActionModal.CompletionDate")}
    >
      <FormDateRangeInput
        name="datetimePerformed"
        placeholder={t("Components.DateField.Range")}
        isViewMode={isViewMode}
        isDisabled={isViewMode}
        shouldHaveErrorBehaviorAfterSubmit
        maxDate={moment().endOf("day")}
        formatValue={(value) => moment(value).toISOString()}
      />
    </DetailSection>
  );
};

export default PerformedDateSpan;
